module.exports = __webpack_public_path__ + "components/flag/static/square/ws-95408fe28cb75e265fbc5f6751522100.svg";